export default __webpack_public_path__ + "static/media/Highjump.efecf6d8.png";